import { showError } from '../../components/Messages';
import { toEntityReference, updateState } from '../../utils/Functions';
import { BaseController } from '../BaseController';

export default class TipoDeEquipamentoController extends BaseController {
   constructor(props) {
      super(props);
      this.name = 'TipoDeEquipamentoController';
   }

   getTitulosDaTabela = () => {
      return [
         { titulo: this.lang.codigo, orderby: 'Id', className: 'codigo' },
         { titulo: this.lang.telaDeCadastroDeTipoDeEquipamento.nome, width: '70%', orderby: 'Nome' },
         { titulo: this.lang.telaDeCadastroDeTipoDeEquipamento.sigla, width: '15%', orderby: 'Sigla' },
         { titulo: this.lang.telaDeCadastroDeTipoDeEquipamento.situacao, width: '15%', orderby: 'Situacao' },
      ];
   };

   getDadosDaTabela = (item) => {
      return [item.id, item.nome, item.sigla, item.situacao?.descricao];
   };

   getObjetoDeDados = () => {
      return new Promise((resolve, reject) => {
         let state = this.view.state;
         let item = state.itemSelecionado;

         if (!item.id) {
            showError(this.lang.telaDeCadastroDeTipoDeEquipamento.mensagens.informeOCodigoDoTipoDeEquipamento);
            reject();
            return;
         }

         if (!item.nome) {
            showError(this.lang.telaDeCadastroDeTipoDeEquipamento.mensagens.informeONomeDoTipoDeEquipamento);
            reject();
            return;
         }

         if (!item.sigla) {
            showError(this.lang.telaDeCadastroDeTipoDeEquipamento.mensagens.informeASiglaDoTipoDeEquipamento);
            reject();
            return;
         }

         if (item.sigla && item.sigla.length > 10) {
            showError(this.lang.telaDeCadastroDeTipoDeEquipamento.mensagens.informeUmTamanhoMenorQue10Siglas);
            reject();
            return;
         }

         if (item.tipoDeSequencia === null || item.tipoDeSequencia === undefined) {
            showError(this.lang.telaDeCadastroDeTipoDeEquipamento.mensagens.informeOTipoDeSequencia);
            reject();
            return;
         }

         if (item.descricao && item.descricao.length > 500) {
            showError(
               this.lang.telaDeCadastroDeTipoDeEquipamento.mensagens.descricaoDoTipoDeEquipamentoAceita500Caracteres
            );
            reject();
            return;
         }

         var input = {
            id: item.id,
            nome: item.nome,
            situacao: item.situacao ? item.situacao.id : 0,
            descricao: item.descricao,
            sigla: item.sigla,
            tipoDeSequencia: item.tipoDeSequencia,
            manual: toEntityReference(item.manual),
            firmwares: item.firmwares,
            anexos: item.anexos,
         };

         if (state.alterando) {
            input.id = parseInt(item.id);
         }
         resolve(input);
      });
   };

   inserirFirmware = () => {
      return new Promise((resolve, reject) => {  
         let firmware = this.view.state.firmwareSelecionado; 

         if (!firmware.numeroDaVersao){
            showError(this.lang.firmware.mensagens.informeONumeroDaVersao);
            reject();
            return;
         }

         if (!firmware.dataDeLiberacao){
            showError(this.lang.firmware.mensagens.informeADataDeLiberacao);
            reject();
            return;
         }

         if (!firmware.descricaoDasAlteracoes){
            showError(this.lang.firmware.mensagens.informeADescricaoDasAlteracoes);
            reject();
            return;
         }

         if (!firmware.arquivoDeFirmware){
            showError(this.lang.firmware.mensagens.selecioneUmArquivoDeFirmware);
            reject();
            return;
         }

         updateState(this.view, (state) => {
            if (!state.itemSelecionado.firmwares) {
               state.itemSelecionado.firmwares = [];
            }
            state.itemSelecionado.firmwares.push({
               dataDeLiberacao: firmware.dataDeLiberacao ? firmware.dataDeLiberacao : new Date(),
               numeroDaVersao: firmware.numeroDaVersao,
               descricaoDasAlteracoes: firmware.descricaoDasAlteracoes,
               arquivoDeFirmware: firmware.arquivoDeFirmware,
            });
         }).then(() => resolve());
      });
   };

   alterarFirmware = (index) => {
      return new Promise((resolve, reject) => {
         let firmware = this.view.state.firmwareSelecionado;
         updateState(this.view, (state) => {
            state.itemSelecionado.firmwares[index].dataDeLiberacao = firmware.dataDeLiberacao;
            state.itemSelecionado.firmwares[index].numeroDaVersao = firmware.numeroDaVersao;
            state.itemSelecionado.firmwares[index].descricaoDasAlteracoes = firmware.descricaoDasAlteracoes;
            state.itemSelecionado.firmwares[index].arquivoDeFirmware = firmware.arquivoDeFirmware;
         }).then(() => resolve());
      });
   };

   inserirAnexo = () => {
      return new Promise((resolve, reject) => {  
         let anexo = this.view.state.anexoSelecionado; 

         if (!anexo.descricao){
            showError(this.lang.anexo.mensagens.informeADescricao);
            reject();
            return;
         }

         if (!anexo.arquivo){
            showError(this.lang.anexo.mensagens.selecioneUmArquivo);
            reject();
            return;
         }

         updateState(this.view, (state) => {
            if (!state.itemSelecionado.anexos) {
               state.itemSelecionado.anexos = [];
            }
            state.itemSelecionado.anexos.push({
               descricao: anexo.descricao,
               anexo: anexo.arquivo,
            });
         }).then(() => resolve());
      });
   };

   alterarAnexo = (index) => {
      return new Promise((resolve, reject) => {
         let anexo = this.view.state.anexoSelecionado;
         updateState(this.view, (state) => {
            state.itemSelecionado.anexos[index].descricao = anexo.descricao;
            state.itemSelecionado.anexos[index].anexo = anexo.arquivo;
         }).then(() => resolve());
      });
   };

   antesDeInserir = () => {
      return new Promise((resolve, reject) => {
         this.view.setState({ podeAlterarCodigo: false });
         resolve();
      });
   };

   antesDeEditar = () => {
      return new Promise((resolve, reject) => {
         this.view.setState({ podeAlterarCodigo: false });
         resolve();
      });
   };
}
